module.exports = __webpack_public_path__ + "static/media/block-user.ced18b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/block-user.png
// module id = 401
// module chunks = 0